// id of the root div contain all widget, used as root selector in main.sass
var CONTAINER_ID = 'subiz'

var sb = require('@sb/util')
import store from '@sb/store'
import bowser from 'bowser'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const loadWidget = () => import(/*webpackChunkName: "widget" */ './Widget.js')

import {directive as onClickaway} from 'vue-clickaway'
Vue.config.productionTip = false
Vue.directive('clickaway', onClickaway)

// chat button is alway shown, so don't bother dynamic loading it
import ChatButton from './ChatButton.js'

var Widget = undefined

var domGate = new sb.Gate()

var main = new Vue({
	i18n: store.i18n,

	data() {
		return {
			isShowWidget: false,
			isShowChatButton: true,
			widgetLoaded: false,
			widgetView: '',
			widgetConvoKey: '',
			rerender: false, // force rerender
			...store.bind(this, ['isBlocked']),
			formMode: '',
			preForm: false,
			postForm: false,
		}
	},

	mounted() {
		domGate.open()
	},

	render() {
		if (this.isBlocked) return null

		var $widget = null
		if (Widget)
			$widget = (
				<Widget
					view={this.widgetView}
					convoKey={this.widgetConvoKey}
					isShow={this.isShowWidget}
					formMode={this.formMode}
					preForm={this.preForm}
					postForm={this.postForm}
					vOn:close={this.onWidgetClose}
					vOn:go={this.onWidgetGo}
				/>
			)

		let isHidden =
			(bowser.mobile && sb.get(store, 'accountSetting.mobile_button.hidden', false)) ||
			(!bowser.mobile && sb.get(store, 'accountSetting.desktop_button.hidden', false))

		var cls = bowser.mobile ? 'mobile' : ''
		if (isHidden) cls += ' d-none'
		return (
			<div id={CONTAINER_ID} data-render={this.rerender}>
				<div class={cls}>
					{$widget}
					<ChatButton
						isShow={this.isShowChatButton}
						vOn:click={this.onChatButtonClick}
						vOn:previewClicked={this.onPreviewClick}
					/>
				</div>
			</div>
		)
	},

	methods: {
		async onWidgetGo(r) {
			return this.showWidget(r.view, {convoKey: r.convoKey})
		},

		async showWidget(view, {convoKey, formMode, preForm, postForm}) {
			if (bowser.mobile) modifyViewport()

			store.sendEventToThirdParty('SUBIZ Chat', 'Opened', 'Subiz Windows')

			this.widgetView = view
			this.widgetConvoKey = convoKey
			this.formMode = formMode
			this.preForm = preForm
			this.postForm = postForm

			// lazy load widget
			if (!Widget) {
				Widget = (await loadWidget()).default

				// hide widget first
				this.isShowWidget = false
				this.rerender = !this.rerender
				await sb.sleep(10)
			}

			this.isShowWidget = true
			this.rerender = !this.rerender
		},

		hideWidget() {
			restoreViewport()
			this.isShowWidget = false
		},

		hideChatButton() {
			this.isShowChatButton = false
		},

		showChatButton() {
			this.isShowChatButton = true
		},

		onWidgetClose() {
			this.showChatButton()
			this.hideWidget()
		},

		async onChatButtonClick() {
			this.hideChatButton()

			let lastview = store.lastview
			if (sb.get(lastview, 'view')) {
				return this.showWidget(lastview.view, lastview.opts)
			}
			if (!sb.get(store.accountSetting, 'is_online')) {
				if (sb.get(store, 'accountSetting.offline_form.enabled'))
					return this.showWidget('form', {formMode: 'offline', preForm: true})
			}

			if (sb.get(store, 'accountSetting.prechat_form.enabled'))
				return this.showWidget('form', {formMode: 'prechat', preForm: true})

			return this.showWidget('chat', {convoKey: ''})
		},

		onPreviewClick(convoKey) {
			this.hideChatButton()

			if (convoKey) {
				let convo = sb.get(store.convoM, convoKey) || {}
				let joined = false
				for (let mem of sb.get(convo, 'members', [])) {
					if (mem.id === store.user.id) joined = true
				}
				if (!joined) {
					if (sb.get(store, 'accountSetting.prechat_form.enabled'))
						return this.showWidget('chat', {convoKey, formMode: 'prechat', preForm: true})
				}
			} else {
				// greeting
				if (!sb.get(store.accountSetting, 'is_online')) {
					if (sb.get(store, 'accountSetting.offline_form.enabled'))
						return this.showWidget('form', {formMode: 'offline'})
				}

				if (sb.get(store, 'accountSetting.prechat_form.enabled')) return this.showWidget('form', {formMode: 'prechat'})
			}
			this.showWidget('chat', {convoKey})
		},
	},
})

function restoreViewport() {
	var viewport = ORIGINVIEWPORT
	const list = []
	for (var field in viewport) {
		list.push(`${field}=${viewport[field]}`)
	}

	ViewportMeta.content = list.join(', ')
}

function modifyViewport() {
	var viewport = Object.assign({}, ORIGINVIEWPORT, {
		'maximum-scale': '1.0',
		'user-scalable': 'no',
		width: 'device-width',
		'initial-scale': '1.0',
	})
	const list = []
	for (var field in viewport) {
		list.push(`${field}=${viewport[field]}`)
	}

	ViewportMeta.content = list.join(', ')
}

var ORIGINVIEWPORT = {}
var ViewportMeta = document.querySelector('meta[name="viewport"]')
if (ViewportMeta) {
	ORIGINVIEWPORT = parseViewportContent(ViewportMeta.content)
} else {
	ViewportMeta = document.createElement('meta')
	ViewportMeta.httpEquiv = 'X-UA-Compatible'
	ViewportMeta.name = 'viewport'
	document.getElementsByTagName('head')[0].appendChild(ViewportMeta)
}

function parseViewportContent(content) {
	let originViewport = {}
	content = content.replace(/([^\s,;]+)(?:[\s]*)?=(?:[\s]*)?([^\s,;]*?)/gi, '$1=$2')
	content = content.replace(/([,;])/gi, ' ')
	content = content.replace(/([\s]+)/gi, ' ')

	const contentParts = content.split(' ')
	for (let contentPart of contentParts) {
		contentPart = contentPart.trim()
		if (contentPart === '') {
			continue
		}

		const parts = contentPart.split('=')
		if (parts.length < 2) {
			continue
		}

		let [field, value] = parts
		field = field.trim()
		value = value.trim()
		originViewport[field] = value
	}
	return originViewport
}

var controller = {
	async showWidget(view, opts) {
		await domGate.entry()
		main.showWidget(view, opts || {})
	},
	async hideWidget() {
		await domGate.entry()
	},
	async showChatButton() {
		await domGate.entry()
	},
	async hideChatButton() {
		await domGate.entry()
	},
	async showConvo(id) {
		await domGate.entry()
		main.showWidget('chat', {convoKey: id})
		main.hideChatButton()
	},
	async showOfflineForm() {
		await domGate.entry()
		main.hideChatButton()
		main.showWidget('form', {formMode: 'offline'})
	},

	async showPrechatForm() {
		await domGate.entry()
		main.hideChatButton()
		main.showWidget('form', {formMode: 'prechat'})
	},

	// should make sure that store is ready before calling this function
	async mount() {
		// add container to client site
		var $div = document.createElement('div')
		document.body.appendChild($div)

		// add google font
		var $link = document.createElement('link')
		$link.href = 'https://fonts.googleapis.com/css?family=Roboto:400,500&display=swap&subset=vietnamese'
		$link.rel = 'stylesheet'
		document.head.append($link)

		main.$mount($div)
	},
}
export default controller
